import { IressAlert } from '@iress-oss/ids-components';
import './ErrorMessage.css';

interface ErrorMessageProps {
  message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="porter-error">
      <IressAlert status="danger">
        {message}
      </IressAlert>
    </div>
  );
}
